import { render } from "./InspectionModal.vue?vue&type=template&id=6b15ddac"
import script from "./InspectionModal.vue?vue&type=script&lang=js"
export * from "./InspectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__